import DatePicker from '../../../../../components/stateless/datePicker/DatePicker';
import { DatePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import DropDown from '../../../../../components/stateless/dropDown/DropDown';
import FileUpload from '../../../../../components/stateful/fileUpload/FileUpload';
import { useChapterHistoryFormController } from './ChapterHistoryFormController';
import { BlobContainer } from '../../../../../utilities/enums/BlobContainer';
import CustomButton from '../../../../../components/stateless/customButton/CustomButton';
import styles from './ChapterHistoryForm.module.scss'

interface IChapterHistoryForm {
    chapter: any,
    reloadChapterHistory: () => void
}

const ChapterHistoryForm = (props: IChapterHistoryForm) => {
    const {
        // Redux
        recordStatuses,

        // State
        selectedRecordStatus,

        // Functions
        handleRecordStatusSelectChange,
        setEffectiveFromDate,
        setEffectiveToDate,
        saveFile,
        deleteFile,
        handleFileUploadResponseMessage,
        handleSave,
    } = useChapterHistoryFormController(props.chapter, props.reloadChapterHistory);

  return (
    <>
        <h3><b>Add New Chapter History</b></h3>
        <form onSubmit={handleSave}>
           <div className={styles.inputContainer}>
               <div>
                   <DatePicker
                       onChange={(date: DatePickerChangeEvent) => {setEffectiveFromDate(date.value);}}
                       label={"Effective From"}
                       size='medium'
                       dateOnly
                   />
               </div>
               <div>
                   <DatePicker
                       onChange={(date: DatePickerChangeEvent) => {setEffectiveToDate(date.value);}}
                       label={"Effective To"}
                        size='medium'
                        dateOnly
                    />
                </div>
                <div className={styles.recordStatus}>
                    <DropDown
                        size="fullwidth"
                        label="Record Status"
                        value={selectedRecordStatus}
                        listItems={recordStatuses}
                        onSelect={handleRecordStatusSelectChange}
                        dataKey="id"
                        textField="recordStatusName"
                    />
                </div>
            </div>
            <div className={styles.uploadContainer}>
                <FileUpload
                    containerName={BlobContainer.historicalChapterPdfContainer}
                    type={'file'}
                    saveFile={saveFile}
                    deleteFile={deleteFile}
                    notification={handleFileUploadResponseMessage}
                    allowedTypes='pdf'
                    useOriginalFileName
                />
            </div>
            <div className={styles.btnContainer}>
                <div>
                    <CustomButton
                        onClick={handleSave}
                        themeColor='success'
                        size='medium'
                    >Save</CustomButton>
                </div>
                {/* <div>
                    <CustomButton
                        onClick={clearFormValues}
                        themeColor='error'
                        size='medium'
                    >Cancel</CustomButton>
                </div> */}
            </div>
        </form>
    </>
  )
}

export default ChapterHistoryForm